import cloneDeep from 'lodash/cloneDeep';
import { util } from '@/api/util/index';
import { apis } from '@/config';
import { api as masterApi } from '@/api/api';
import { YUNXIN_NONE_SENTINEL } from './util/const';
export class ContactImplSearch {
    constructor(ctx) {
        this.ctx = ctx;
    }
    async doSearchContactByAccounts(condition) {
        return {};
    }
    async doSearchContactByAccountsInMemory(condition) {
        const start = Date.now();
        console.warn('[contact_doSearchContactByAccountsInMemory_start]');
        let accounts = [];
        if (condition._account) {
            accounts = [{ id: condition._account }];
        }
        else {
            accounts = await this.ctx.accountApi.getMainAndSubAccounts();
        }
        console.warn('[contact] doSearchContactByAccountsInMemory getMainAndSubAccounts', this.ctx.contactUtil.useTime(start));
        let result = {};
        if (accounts && accounts.length) {
            const list = await Promise.all(accounts.map((account) => this.doSearchAllContactInMemory(Object.assign(Object.assign({}, condition), { _account: account.id })).then(data => Promise.resolve({ [account.id]: data }))));
            list.forEach(item => {
                result = Object.assign(Object.assign({}, result), item);
            });
        }
        console.warn('[bigDataSearch] [contact_doSearchContactByAccountsInMemory_end]', this.ctx.contactUtil.useTime(start));
        return result;
    }
    async doSearchTeamContact(query, _account) {
        return {
            contactList: [],
            teamList: [],
        };
    }
    doSearchAllContactNew(condition, onResult) {
        this.doSearchNew(condition, onResult);
    }
    transSearchCustomerRes2CustomerSearchContactMemoryRes(res) {
        const { customerList, customerContactList } = res;
        const _lastUpdateTime = Date.now();
        const contact = customerContactList.map(item => {
            const { customerId: orgId, contactId: id, contactName, contactEmail: accountName, contactCreateTime: createTime } = item;
            const obj = {
                orgId,
                id,
                accountName,
                createTime,
                contactName: contactName || '',
                type: 'customer',
                customerRole: 'myCustomer',
                contactPYName: '',
                contactPYLabelName: '',
                _lastUpdateTime,
            };
            return obj;
        });
        const customer = customerList.map(item => {
            const { customerId: id, customerName: orgName, customerCreateTime: orgRank } = item;
            const obj = {
                id,
                originId: id,
                orgRank,
                orgName: orgName || '',
                type: 2002,
                customerRole: 'myCustomer',
                orgPYName: '',
                _lastUpdateTime,
                _company: '',
                customerType: 'customer',
            };
            return obj;
        });
        const result = {
            contact,
            customer,
            clue: [],
        };
        return result;
    }
    needServerSearch(_account) {
        const config = this.ctx.contactSync.getEnterpriseConfig(_account);
        if (!config) {
            return true;
        }
        return !(config.hasAllContacts === 1 && config.hasSearchRule === 0);
    }
    shouldSkipServerSearch(keyword, accountLocalResult, _account) {
        var _a, _b, _c, _d;
        const config = this.ctx.contactSync.getEnterpriseConfig(_account);
        const keywordMinLength = (_a = config === null || config === void 0 ? void 0 : config.serverSearchKeywordLength) !== null && _a !== void 0 ? _a : 1;
        const localThreshold = (_b = config === null || config === void 0 ? void 0 : config.serverSearchLocalThreshold) !== null && _b !== void 0 ? _b : this.ctx.contactUtil.LOCAL_ENTERPRISE_SKIP_THRESHOLD;
        if (keyword.length <= keywordMinLength) {
            return true;
        }
        const localContactCount = (_d = (_c = accountLocalResult === null || accountLocalResult === void 0 ? void 0 : accountLocalResult.contactList) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
        return localContactCount >= localThreshold;
    }
    async doServerSearch(params) {
        const { keyword, account, accountLocalResult, noRelateEnterprise } = params;
        const serverContacts = await this.fetchServerContacts(keyword, account, noRelateEnterprise);
        if (!serverContacts.length) {
            return accountLocalResult;
        }
        const { mergedResult, toWriteBack } = this.mergeServerContactsIntoLocal(accountLocalResult, serverContacts);
        this.writeBackServerSearchResults(toWriteBack, account, keyword);
        return mergedResult;
    }
    async fetchServerContacts(keyword, account, noRelateEnterprise) {
        const currentUser = this.ctx.systemApi.getCurrentUser(account);
        const allDomains = noRelateEnterprise ? [currentUser === null || currentUser === void 0 ? void 0 : currentUser.domain].filter((d) => Boolean(d)) : this.ctx.contactServer.getAllDomains(account);
        const searchResults = await Promise.all(allDomains.map(d => this.ctx.contactServer.searchEnterpriseContacts(keyword, d)));
        const seenIds = new Set();
        const serverContacts = [];
        for (const res of searchResults) {
            for (const c of res.contacts || []) {
                if (!seenIds.has(c.id)) {
                    seenIds.add(c.id);
                    serverContacts.push(c);
                }
            }
        }
        return serverContacts;
    }
    mergeServerContactsIntoLocal(accountLocalResult, serverContacts) {
        const mergedResult = cloneDeep(accountLocalResult);
        const toWriteBack = [];
        const localContactMap = new Map();
        mergedResult.contactList.forEach((c, index) => {
            if (c.type === 'enterprise') {
                localContactMap.set(c.id, { index, contact: c });
            }
        });
        const toAppend = [];
        serverContacts.forEach(serverItem => {
            const localEntry = localContactMap.get(serverItem.id);
            if (!localEntry) {
                toAppend.push(this.ctx.contactTrans.transNewServerSearchResult2ContactSearch(serverItem, '', ''));
                toWriteBack.push(serverItem);
            }
            else {
                const local = localEntry.contact;
                const serverName = serverItem.name;
                const serverEmail = serverItem.email.toLowerCase();
                const serverPosition = JSON.stringify(serverItem.unitNames);
                const localPosition = JSON.stringify(local.position || []);
                const infoChanged = local.contactName !== serverName || local.accountName !== serverEmail || localPosition !== serverPosition;
                if (infoChanged) {
                    const updatedContact = this.ctx.contactTrans.transNewServerSearchResult2ContactSearch(serverItem, local.avatar || '', local.avatarPendant || '');
                    mergedResult.contactList[localEntry.index] = updatedContact;
                    toWriteBack.push(serverItem);
                }
            }
        });
        mergedResult.contactList = [...mergedResult.contactList, ...toAppend];
        return { mergedResult, toWriteBack };
    }
    writeBackServerSearchResults(toWriteBack, account, keyword) {
        var _a;
        if (!toWriteBack.length) {
            return;
        }
        const enterpriseId = (_a = this.ctx.systemApi.getCurrentCompanyId(account)) !== null && _a !== void 0 ? _a : -1;
        const contacts = toWriteBack.map(item => this.ctx.contactTrans.transSearchServerContact2EntityContact(item, enterpriseId));
        const contactItems = toWriteBack.flatMap(item => this.ctx.contactTrans.transSearchServerContact2EntityContactItem(item, enterpriseId));
        const lokiApi = masterApi.requireLogicalApi(apis.dbMemoryApiImpl);
        this.ctx.contactDB
            .searchResultInto(lokiApi, contacts, contactItems, account)
            .then(() => {
            var _a;
            (_a = this.ctx.contactSync.tracker) === null || _a === void 0 ? void 0 : _a.recordIncrementalOp({
                api: 'searchEnterpriseContacts',
                timestamp: Date.now(),
                returnCount: toWriteBack.length,
                targetTables: ['contact', 'contactItem'],
                dexieWritten: contacts.length,
                lokiWritten: contacts.length,
                params: `keyword=${keyword}`,
            });
        })
            .catch(e => {
            console.error('[contact] doServerSearch writeBack failed', e);
        });
    }
    doSearchNew(condition, onResult) {
        var _a;
        const { query: keyword = '', noRelateEnterprise = false } = condition;
        if (!keyword.trim()) {
            const currentUserId = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
            onResult({
                main: {
                    [currentUserId]: {
                        frequentContactList: [],
                        contactList: [],
                        teamList: [],
                        orgList: [],
                        personalOrgList: [],
                    },
                },
                keyword,
            });
            return;
        }
        this.doSearchInMemory(condition).then(localResult => {
            onResult(Object.assign(Object.assign({}, localResult), { keyword }));
            this.doMultiAccountServerSearch(keyword, noRelateEnterprise, localResult).then(mergedResult => {
                if (mergedResult) {
                    onResult(Object.assign(Object.assign({}, mergedResult), { keyword }));
                }
            });
        });
    }
    getAccountsNeedingServerSearch(keyword, localResult) {
        return Object.keys(localResult.main).filter(account => {
            const accountLocalResult = localResult.main[account];
            if (!accountLocalResult) {
                return false;
            }
            if (this.shouldSkipServerSearch(keyword, accountLocalResult, account)) {
                return false;
            }
            if (!this.needServerSearch(account)) {
                return false;
            }
            return true;
        });
    }
    async doMultiAccountServerSearch(keyword, noRelateEnterprise, localResult) {
        const accountsToSearch = this.getAccountsNeedingServerSearch(keyword, localResult);
        if (!accountsToSearch.length) {
            return null;
        }
        const results = await Promise.all(accountsToSearch.map(account => this.doServerSearch({
            keyword,
            account,
            accountLocalResult: localResult.main[account],
            noRelateEnterprise,
        }).catch(e => {
            console.warn(`[contact.doSearchNew] server search failed for account ${account}, ignored`, e);
            return localResult.main[account];
        })));
        const mergedMain = Object.assign({}, localResult.main);
        accountsToSearch.forEach((account, index) => {
            mergedMain[account] = results[index];
        });
        return { main: mergedMain, edm: localResult.edm };
    }
    async doSearchInMemory(condition) {
        const start = Date.now();
        const main = await this.doSearchContactByAccountsInMemory(condition);
        console.warn('[contact] doSearchInMemory', this.ctx.contactUtil.useTime(start));
        return {
            main: cloneDeep(main),
            edm: undefined,
        };
    }
    async doGetContactByIdsNew(ids) {
        return this.ctx.facade.doGetContactById(ids);
    }
    async doSearch(condition) {
        return {
            main: {},
            edm: undefined,
        };
    }
    async doSearchAllContactInMemory(condition) {
        const { query, _account, maxItem = this.ctx.contactUtil.searchTableLimit, lastId, noRelateEnterprise = false } = condition;
        console.time('[contact] doSearchAllContactInMemory');
        const tableCondition = this.ctx.contactDB.transMemorySearchCondition(condition);
        const promiseList = tableCondition.map(condi => {
            const { tableName, searchFilterList } = condi;
            return this.ctx.contactDB
                .searchTable({
                dbName: this.ctx.contactUtil.contactSearchDbName,
                searchFilterList,
                tableName,
                _account,
                filterLimit: maxItem,
                lastId,
                noRelateEnterprise,
            })
                .then(res => ({
                [tableName]: res,
            }));
        });
        const data = await Promise.all(promiseList);
        let res = {};
        data.forEach(item => {
            res = Object.assign(Object.assign({}, res), item);
        });
        const pureContactMap = new Map();
        (res.contact || []).forEach(_item => {
            var _a, _b;
            const item = util.addHitQuery({
                data: _item,
                queryList: [query],
                hitList: ['contactName', 'contactPYName', 'contactPYLabelName', 'accountName'],
            });
            if (condition.flattenMuliptleEmails) {
                pureContactMap.set(item.id + item.accountName, item);
                const emails = item.emails || [];
                emails.forEach((email) => {
                    if (email && email !== item.accountName) {
                        pureContactMap.set(item.id + email, Object.assign(Object.assign({}, item), { accountName: email }));
                    }
                });
                return;
            }
            pureContactMap.set(item.id, Object.assign(Object.assign({}, item), { emailCount: 1 + ((_b = (_a = item.emails) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) }));
        });
        const { defaultOrderList: defaultContactList, frequentOrderList: frequentContactList } = await this.ctx.contactDB.sortSearchResult({
            list: [...pureContactMap.values()],
            idKeypath: 'id',
            handleSameIdType: condition.flattenMuliptleEmails ? 'flatten' : 'replace',
            useFrequentOrder: condition.useFrequentOrder,
            frequentChannel: condition.frequentChannel,
            frequentOrderCount: condition.frequentOrderCount,
            _account: condition._account || '',
            query,
            orderBy: ['contactName', 'contactPYName', 'contactPYLabelName', 'accountName'],
        });
        const orgList = [];
        const teamList = [];
        const personalOrgList = [];
        let orgDataList = (res.org || []);
        if (orgDataList.length) {
            orgDataList = util.setDataOrder({
                data: orgDataList,
                orderBy: [['orgRank', false], 'orgName', 'orgPYName'],
            });
            orgDataList.forEach(item => {
                if (item.type === 2000) {
                    teamList.push(item);
                }
                else if (item.type === 2001) {
                    personalOrgList.push(item);
                }
                else {
                    orgList.push(item);
                }
            });
        }
        console.timeEnd('[contact] doSearchAllContact2');
        console.log('[contact] doSearchAllContact2', {
            defaultContactList,
            frequentContactList,
        });
        const displayLimit = this.ctx.contactUtil.searchResultDisplayLimit;
        const contactList = defaultContactList.length > displayLimit ? defaultContactList.slice(0, displayLimit) : defaultContactList;
        return {
            orgList,
            personalOrgList,
            teamList,
            contactList,
            frequentContactList,
        };
    }
    async doSearchAllContact(_condition) {
        return {
            frequentContactList: [],
            contactList: [],
            orgList: [],
            teamList: [],
            personalOrgList: [],
        };
    }
    async doCorpSearch(query, contactModelList) {
        console.log('[contact_impl]doCorpSearch', query, contactModelList);
        return [];
    }
    async doSearchContact(query, isIM, noLock) {
        return [];
    }
    async batchEnsureYunxinByIds(contactIds, account) {
        const result = new Map();
        if (!contactIds.length) {
            return result;
        }
        const lxInfoList = await this.ctx.contactDB.readLxInfoByIds(contactIds, account);
        const lxInfoMap = new Map(lxInfoList.map(row => [row.contactId, row]));
        for (const id of contactIds) {
            const info = lxInfoMap.get(id);
            if (info && info.yxid) {
                result.set(id, { yxid: info.yxid, yxToken: info.yxToken || '' });
            }
        }
        const missingIds = contactIds.filter(id => {
            const info = lxInfoMap.get(id);
            return !info || !info.yxid;
        });
        if (missingIds.length) {
            try {
                const serverContacts = await this.ctx.contactServer.getContactByQiyeAccountId({
                    idList: missingIds,
                    _account: account,
                });
                if (serverContacts.length) {
                    const lokiApi = this.ctx.lokiApi;
                    const entityContacts = [];
                    const entityContactItems = [];
                    const lxInfoRows = [];
                    const fetchedIds = new Set();
                    serverContacts.forEach(model => {
                        entityContacts.push(model.contact);
                        entityContactItems.push(...(model.contactInfo || []));
                        fetchedIds.add(model.contact.id);
                        const yunxinItem = (model.contactInfo || []).find((ci) => ci.contactItemType === 'yunxin');
                        const yxid = (yunxinItem === null || yunxinItem === void 0 ? void 0 : yunxinItem.contactItemVal) || YUNXIN_NONE_SENTINEL;
                        const yxToken = (yunxinItem === null || yunxinItem === void 0 ? void 0 : yunxinItem.contactItemRefer) || '';
                        lxInfoRows.push({
                            contactId: model.contact.id,
                            avatar: model.contact.avatar || '',
                            avatarPendant: model.contact.avatarPendant || '',
                            yxid,
                            yxToken,
                        });
                        result.set(model.contact.id, { yxid, yxToken });
                    });
                    for (const id of missingIds) {
                        if (!fetchedIds.has(id)) {
                            lxInfoRows.push({ contactId: id, yxid: YUNXIN_NONE_SENTINEL, yxToken: '' });
                            result.set(id, { yxid: YUNXIN_NONE_SENTINEL, yxToken: '' });
                        }
                    }
                    this.ctx.contactDB.contactDetailInto(lokiApi, entityContacts, entityContactItems, lxInfoRows, account).catch(e => {
                        console.error('[contact] batchEnsureYunxinByIds writeBack failed', e);
                    });
                }
                else {
                    const lokiApi = this.ctx.lokiApi;
                    const lxInfoRows = missingIds.map(id => ({ contactId: id, yxid: YUNXIN_NONE_SENTINEL, yxToken: '' }));
                    missingIds.forEach(id => result.set(id, { yxid: YUNXIN_NONE_SENTINEL, yxToken: '' }));
                    this.ctx.contactDB.contactDetailInto(lokiApi, [], [], lxInfoRows, account).catch(e => {
                        console.error('[contact] batchEnsureYunxinByIds writeBack failed', e);
                    });
                }
            }
            catch (e) {
                console.warn('[contact] batchEnsureYunxinByIds server fetch failed', e);
            }
        }
        return result;
    }
    async enrichContactsWithYunxin(contacts, account) {
        if (!contacts.length) {
            return [];
        }
        const contactIds = contacts.map(c => c.id);
        const yunxinMap = await this.batchEnsureYunxinByIds(contactIds, account);
        return contacts
            .map(c => {
            const info = yunxinMap.get(c.id);
            return Object.assign(Object.assign({}, c), { yxId: (info === null || info === void 0 ? void 0 : info.yxid) || '', yxToken: (info === null || info === void 0 ? void 0 : info.yxToken) || '' });
        })
            .filter(c => c.yxId && c.yxId !== YUNXIN_NONE_SENTINEL);
    }
    doSearchServerYxContact(query, onResult) {
        var _a;
        const account = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        this.doSearchNew({
            query,
            isIM: true,
            showDisable: false,
            contactType: 'enterprise',
            noRelateEnterprise: true,
        }, res => {
            var _a;
            const contactList = ((_a = res.main[account]) === null || _a === void 0 ? void 0 : _a.contactList) || [];
            this.enrichContactsWithYunxin(contactList, account).then(enriched => {
                onResult(enriched);
            });
        });
    }
}
